import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.date.to-json.js";
// Vendors
import Keycloak from 'keycloak-js';
import cookies from "../cookies/cookies";
import session from "../session/session.utils";
// Utils
import { getCookieDomain, isCurrentDomain } from "../session/utils/session.utils.utils";
// Constants
import constants from "./constants/keycloak.constants";
import storageConstants from "../../constants/storage";
// Types

var keycloak;
var promiseCallback = function promiseCallback(_ref) {
  var callback = _ref.callback,
    onError = _ref.onError;
  var _keycloak = keycloak,
    authenticated = _keycloak.authenticated,
    token = _keycloak.token;
  if (token && authenticated) {
    var domain = cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN_ORIGIN);
    if (!isCurrentDomain(domain)) {
      session.clearSessionData();
      var domainValue = window.location.hostname;
      cookies.setCookie({
        name: storageConstants.COOKIES_IDS.ACCESS_TOKEN_ORIGIN,
        value: domainValue,
        domain: getCookieDomain()
      });
    }
    cookies.setCookie({
      name: storageConstants.COOKIES_IDS.ACCESS_TOKEN,
      value: token,
      domain: getCookieDomain()
    });
    callback && callback([{
      accessToken: token
    }]);
    keycloak.onAuthRefreshSuccess = function () {
      return window.console.log('Keycloak token refreshed!!');
    };
    keycloak.onAuthSuccess = function () {
      return window.console.log('Keycloak authed successfully!!');
    };
    keycloak.onAuthError = function (error) {
      return window.console.log('Keycloak authed successfully!!' + JSON.stringify(error));
    };
    keycloak.onAuthRefreshError = function (error) {
      return window.console.log('Keycloak token not refreshed!!' + JSON.stringify(error));
    };
    return true;
  } else {
    onError && onError();
    return false;
  }
};
var doKeycloakLogout = function doKeycloakLogout() {
  return keycloak.logout({
    redirectUri: window.location.origin
  });
};
var initKeycloakLogin = function initKeycloakLogin(_ref2) {
  var callback = _ref2.callback,
    onError = _ref2.onError,
    _ref2$extraInitConfig = _ref2.extraInitConfiguration,
    extraInitConfiguration = _ref2$extraInitConfig === void 0 ? {} : _ref2$extraInitConfig;
  keycloak = Keycloak(constants.KEYCLOAK_CONFIGURATION);
  return keycloak.init(_objectSpread(_objectSpread({}, constants.INIT_CONFIGURATION), extraInitConfiguration)).then(function (action) {
    return promiseCallback({
      action: action,
      callback: callback,
      onError: onError
    });
  })["catch"](onError);
};
var refreshKeycloakToken = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
    var onError, domain;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          onError = _ref3.onError;
          domain = cookies.getCookie(storageConstants.COOKIES_IDS.ACCESS_TOKEN_ORIGIN);
          if (!(keycloak.isTokenExpired(60) || !isCurrentDomain(domain))) {
            _context.next = 10;
            break;
          }
          _context.next = 5;
          return keycloak.updateToken(60);
        case 5:
          _context.next = 7;
          return promiseCallback({
            onError: onError
          });
        case 7:
          return _context.abrupt("return", _context.sent);
        case 10:
          return _context.abrupt("return", true);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function refreshKeycloakToken(_x) {
    return _ref4.apply(this, arguments);
  };
}();
export default {
  doKeycloakLogout: doKeycloakLogout,
  initKeycloakLogin: initKeycloakLogin,
  refreshKeycloakToken: refreshKeycloakToken
};